import * as AlertDialog from "@radix-ui/react-alert-dialog";
import "./AlertDialogUI.scss";
import { Button, Row } from "@/components";
import { CheckCircle, ErrorExagon } from "../../../icons";

type AlertDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
  confirmBtnLabel?: string;
  role?: "alertdialog" | "dialog";
  variant?: "default" | "error" | "success";
};

export const AlertDialogUI = ({
  title = "Alert",
  description = "Funzione al momento non ancora disponibile",
  confirmBtnLabel = "OK",
  isOpen,
  onClose,
  variant = "default",
  role = "alertdialog",
}: AlertDialogProps) => (
  <AlertDialog.Root open={isOpen} onOpenChange={onClose}>
    <AlertDialog.Portal>
      <AlertDialog.Overlay className="ui-alertDialogOverlay" />
      <AlertDialog.Content
        className="ui-alertDialogContent fs-6 text-slate-28"
        role={role}
      >
        <AlertDialog.Title className="ui-alertDialogTitle fw-bold fs-custom text-slate-20">
          {variant === "error" && <ErrorExagon width={20} height={20} />}
          {variant === "success" && (
            <CheckCircle color="status-success" width={20} height={20} />
          )}
          {title}
        </AlertDialog.Title>
        <AlertDialog.Description className="ui-alertDialogDescription">
          {description}
        </AlertDialog.Description>
        <Row justifyContent={"flex-end"}>
          <AlertDialog.Cancel asChild>
            <Button variant={"primary"} size={"3"}>
              {confirmBtnLabel}
            </Button>
          </AlertDialog.Cancel>
        </Row>
      </AlertDialog.Content>
    </AlertDialog.Portal>
  </AlertDialog.Root>
);
